import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  background-color: var(--white_gray);

  > main {
    width: 100%;
  }

  &.layout-home .header {
    background-color: var(--black) !important;
  }

  #height-swap {
    display: block;
    width: 100%;
    height: 0;
    overflow: hidden;
  }
`;
